// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PfTH","top":"styles_top__3fjp8"};